import {
  ENROLL_FOR_FREE_REQUEST,
  ENROLL_FOR_FREE_SUCCESS,
  ENROLL_FOR_FREE_FAILURE,
} from "../Actions/types";

const initialState = {
  loading: false,
  success: false,
  error: null,
  enrollmentData: null,
};

const enrollReducer = (state = initialState, action) => {
  switch (action.type) {
    case ENROLL_FOR_FREE_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };
    case ENROLL_FOR_FREE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        enrollmentData: action.payload, // Save the enrollment data
        error: null,
      };
    case ENROLL_FOR_FREE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload, // Save the error message
      };
    default:
      return state;
  }
};

export default enrollReducer;
